import { render, staticRenderFns } from "./contact-lists-selector.vue?vue&type=template&id=ec1b65cc"
import script from "./contact-lists-selector.vue?vue&type=script&lang=js"
export * from "./contact-lists-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports